.AnalogClockContainer {
    position: relative;
    width: fit-content;
    user-select: none;
}
.AnalogClockContainer:hover {
    filter: none !important;
}

.ClockFace {
    z-index: 1;
    transform: translate(20px, 42px);
    user-select: none;
}

.SecondHand {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform-origin: 20px 50%;
    user-select: none;
}

.MinuteHand {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    transform-origin: 20px 50%;
    user-select: none;
}

.HourHand {
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 50%;
    transform-origin: 20px 50%;
    user-select: none;
}

.AnalogClockContainer.ScaledDown {
    transform: translate(-500px, -550px) scale(0.2);
}
